// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import configureStore from './app/configure/configureStore';
import { Theme } from './designTokens';
import Root from './app/configure/Root';
import { resolveApiEndpoints } from './lib/api';

const THHockeyChallenge = () => {
  const urlParams = new URLSearchParams(window.location.search);

  // eslint-disable-next-line no-unused-vars
  const platform = urlParams.get('isNative') === 'true' ? 'mobile' : 'web';
  // eslint-disable-next-line no-unused-vars
  const env = urlParams.get('env') ? urlParams.get('env') : 'staging';
  const userId = urlParams.get('userId');
  // eslint-disable-next-line no-unused-vars
  const language = urlParams.get('timsLang') ? urlParams.get('timsLang') : 'en';
  const routeBase = '';
  const { apiUrl, graphqlUrl } = resolveApiEndpoints(env);

  // Memoize the store so that rerenders don't cause multiple stores to be created
  const store = React.useMemo(() => {
    return configureStore({
      config: {
        fetchErrorCount: 0,
        routeBase,
        userId,
        currentSession: null,
        language,
        apiUrl,
        graphqlUrl,
        env,
        platform,
      },
    });
  }, []);

  return <Root store={store} theme={Theme.challenge20} />;
};

export default THHockeyChallenge;
